module.exports = __webpack_public_path__ + "static/media/travel.dfeed2f7.svg";